import { Component, Inject, OnInit } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef,
} from '@angular/material/dialog';
import { FormBuilder } from '@angular/forms';
import { NotifierService } from '../../../../../../../core/service/notifier.service';
import { BuildRenovateService } from '../../../../../../../core/service/buildRenovate.service';
@Component({
  selector: 'app-dialog-reserved-content',
  templateUrl: './dialog-info-wallet.component.html',
  styleUrls: ['./dialog-info-wallet.component.scss'],
})
export class DialogInfoWalletComponent implements OnInit {
  info: any;

  constructor(
    public dialogRef: MatDialogRef<DialogInfoWalletComponent>,
    public dialog: MatDialog,
    private _formBuilder: FormBuilder,
    private buildRenovateService: BuildRenovateService,
    private _notifierService: NotifierService,
    @Inject(MAT_DIALOG_DATA) private data: DialogInfoWalletComponent
  ) {}

  ngOnInit(): void {}
  confirmChange() {
    this.dialogRef.close({ data: 'conferma' });
  }
}
